import styled from 'styled-components';
import { Button, Input } from 'reactstrap';


export const InputAuth = styled(Input)`
  height: 50px;
  width: 100%;
  border-radius: 40px;
  text-align: left;
  padding: 10px 25px;
  font-family: 'Raleway', sans-serif;
  font-weight: 400;
  font-size: 16px;

  /* Ajustes responsivos para o input */
  @media (max-width: 768px) {
    font-size: 14px; /* Diminui o tamanho da fonte para telas menores */
  }
`;


export const ButtonAuth = styled(Button)`
  width: 100%;
  padding: 10px;
  border-radius: 25px;
  font-size: 18px;
  background: linear-gradient(268.2deg, #006EB0 -5.28%, #00AFEF 100%, #007DC3 100%);
  border: none;

  /* Ajuste da responsividade no botão */
  @media (max-width: 768px) {
    font-size: 16px; /* Diminui o tamanho da fonte do botão em telas menores */
  }
`;

export const InstructionText = styled.div`
  font-size: 14px;
  color: #555;
  margin-top: 1px;
  text-align: left;

  ul {
    padding-left: 20px;
  }

  li {
    margin-bottom: 5px;
  }

  /* Responsividade para o texto de instrução */
  @media (max-width: 768px) {
    font-size: 12px; /* Diminui o tamanho da fonte */
  }
`;

export const EyeIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 18px;
  color: #555;
`;

export const CustomModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;

export const CustomModal = styled.div`
  background: white;
  padding: 30px;
  border-radius: 10px;
  max-width: 500px;
  width: 90%;
  text-align: center;
`;

export const ModalHeader = styled.h2`
  font-size: 20px;
  margin-bottom: 20px;
`;

export const ModalBody = styled.div`
  margin-bottom: 20px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const ButtonLogin = styled(Button)`
  width: auto; /* Ajustar a largura para ser automática */
  padding: 10px 25px;
  border-radius: 40px;
  border: none;
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size: 20px;
  height: 50px;
  background: linear-gradient(268.2deg, #006EB0 -5.28%, #00AFEF 100%, #007DC3 100%);
  position: relative;
  margin-top: 5px; /* Espaço entre o botão e os campos de entrada */
  
      @media (max-width: 767px) {
      font-size: 16px;
      height: 45px;
      padding: 8px 20px;
  }
`;
export const InputLogin = styled(Input)`
  height: 50px;
  width: 100%;
  border-radius: 40px;
  text-align: left;
  padding: 10px 40px 10px 25px; /* Aumenta o padding à direita para dar espaço ao ícone */
  font-family: 'Raleway', sans-serif;
  font-weight: 400;
  font-size: 16px;


  /* Media Query para telas menores */
  @media (max-width: 768px) {
    padding-right: 35px;  /* Dá mais espaço para o ícone em telas menores */
  }

  @media (max-width: 480px) {
    padding-right: 30px;  /* Ajuste adicional para telas muito pequenas */
  }
`;




export const RegisterLink = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  cursor: pointer;
  color: #0C2B6E;
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  text-decoration: underline;

  svg {
    margin-right: 5px;
  }
`;


export const ProgressBar = styled.div`
  width: ${(props) => props.strength}%;
  height: 15px;
  border-radius: 50px;
  background-color: ${(props) => {
    if (props.strength === 0) return '#ccc'; // Barra vazia (sem senha)
    if (props.strength < 50) return 'red'; // Menos de 50% força -> vermelho
    if (props.strength < 75) return 'orange'; // Entre 50% e 74% -> laranja
    if (props.strength < 100) return 'yellow'; // Entre 75% e 99% -> amarelo
    return 'green'; // Força 100% -> verde
  }};
  transition: width 0.5s ease-in-out, background-color 0.5s ease-in-out;
`;

export const ProgressBarWrapper = styled.div`
 margin-top: 15px;
  width: 100%;   
  border: 1px solid #cccccc85;  /* Borda fina e cinza */
  box-sizing: border-box;
  border-radius: 50px; 
/*   box-shadow: 1px 1px 1px 1px rgba(0.1, 0.1, 0.1, 0.1); */
`;


export const IdDocLogo = styled.img`
 position: relative; // Manter a posição absoluta
  bottom: 0px;       // Posição inferior
  margin-top:10px;
  width: 100px;       // Largura da imagem
    @media (max-width: 400px) {
    width: 100%;   /* Ajusta o tamanho em telas menores */
    max-width: 150px; /* Logo menor em dispositivos móveis */
     position: relative;
  }
         @media (max-width: 800px) {
    width: 100%;   /* Ajusta o tamanho em telas menores */
    max-width: 180px; /* Logo menor em dispositivos móveis */
     position: relative;
  }
`;

export const CaptchaBox = styled.div`
  margin: 20px 0;
/*   display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;  /* Certifique-se de que o contêiner tenha altura suficiente */

  .g-recaptcha {
    width: 10%;
    max-width: 304px; /* Defina um limite máximo de largura */
  }

  /* Para telas pequenas */
  @media only screen and (max-width: 500px) {
    .g-recaptcha {
      width: 100%; /* Garante que ocupe a largura total */
      transform: scale(0.77); /* Reduz o tamanho */
      transform-origin: 0 0; /* Garante que a transformação seja feita a partir do canto superior esquerdo */
    }
  } */
`;

